
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form } from "vee-validate";
import * as Yup from "yup";
import TextInput from "@/components/TextInput.vue";
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { NH1, NP } from "naive-ui";

export default defineComponent({
  name: "ChangePassword",
  components: {
    TextInput,
    Form,
    NH1,
    NP,
  },
  setup() {
    const { state, dispatch } = useStore();
    const router = useRouter();

    const hidePassword = ref(true);
    const passwordFieldIcon = computed(() => (hidePassword.value ? "fa-eye" : "fa-eye-slash"));
    const passwordFieldType = computed(() => (hidePassword.value ? "password" : "text"));
    const isLoading = computed(() => state.isLoading);

    const { currentUser } = state;
    let isWrong = false;
    const password = ref("");
    const confirmPassword = ref("");

    const onInvalidSubmit = () => {
      const submitBtn: any = document.querySelector(".submit-btn");
      submitBtn.classList.add("invalid");
      setTimeout(() => {
        submitBtn.classList.remove("invalid");
      }, 1000);
    };

    const schema = Yup.object().shape({
      password: Yup.string().min(6).max(20).required(),
      confirmPassword: Yup.string()
        .required()
        .oneOf([Yup.ref("password")], "Пароль не совпадает"),
    });

    // eslint-disable-next-line no-shadow
    const handleChangePassword = async ({ password }: Record<string, any>) => {
      const { email } = currentUser;
      const { id } = currentUser;
      if (password !== "") {
        const userData = {
          password,
          email,
          id,
        };

        try {
          await dispatch("changePassword", userData);
          if (state.isRegistered === true) {
            router.push(`/check-email/${userData.email}`);
          }
          isWrong = false;
        } catch (error) {
          isWrong = true;
        }
      }
    };

    return {
      schema,
      isWrong,
      password,
      isLoading,
      hidePassword,
      confirmPassword,
      onInvalidSubmit,
      passwordFieldIcon,
      passwordFieldType,
      handleChangePassword,
      currentUser: state.currentUser,
    };
  },
});
